import { TuiTable } from '@taiga-ui/addon-table';
import { TuiBadge } from '@taiga-ui/kit';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TuiIcon, TuiHint } from '@taiga-ui/core';
import { TranslatePipe } from '@ngx-translate/core';
import { AlternativeRequestModel } from '@core/models';
import { AlternativeRequestProduct } from '@core/types';
import { RequestReleaseTimeParserPipe } from '@core/pipes';
import { RouterLink } from '@angular/router';
import {
  counterpartyIconResolver,
  leaseProductIconResolver,
} from '@core/helpers';
import { SvgIconComponent } from '@common/components/svg-icon/svg-icon.component';

@Component({
  selector: '[x-alternative-requests-widget-desktop-row]',
  standalone: true,
  imports: [
    SvgIconComponent,
    CommonModule,
    NgOptimizedImage,
    TuiBadge,
    TuiHint,
    TuiIcon,
    TuiTable,
    TranslatePipe,
    RequestReleaseTimeParserPipe,
    RouterLink,
  ],
  templateUrl: './alternative-requests-widget-desktop-row.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AlternativeRequestsWidgetDesktopRowComponent {
  readonly $request = input.required<AlternativeRequestModel>({
    alias: 'request',
  });
  protected readonly today = new Date();
  protected readonly counterpartyIconResolver = counterpartyIconResolver;
  protected readonly leaseProductIconResolver = leaseProductIconResolver;

  getDateFormat(value: string | null): string {
    if (!value) {
      return 'd MMMM';
    }

    return new Date(value).getFullYear() !== this.today.getFullYear()
      ? 'd MMMM yyyy'
      : 'd MMMM';
  }

  getProductTime(product: AlternativeRequestProduct): string | undefined {
    if (product.scheduledAt) {
      return product.scheduledAt;
    }

    return this.$request().releaseTime ?? undefined;
  }

  getAddressHint(): string {
    const request = this.$request();

    if (
      request.actualDeliveryAddress &&
      request.deliveryAddress &&
      request.actualDeliveryAddress !== request.deliveryAddress
    ) {
      return 'requests_list_item.delivery_address_different_from_actual';
    }

    if (
      request.actualDeliveryAddress &&
      request.actualDeliveryAddress === request.deliveryAddress
    ) {
      return 'requests_list_item.delivery_address_confirmed';
    }

    return '';
  }

  get deliveryAddressConfirmed(): boolean {
    const request = this.$request();

    return Boolean(
      request.actualDeliveryAddress &&
      request.actualDeliveryAddress === request.deliveryAddress,
    );
  }

  get deliveryAddressDifferentFromActual(): boolean {
    const request = this.$request();

    return Boolean(
      request.actualDeliveryAddress &&
      request.deliveryAddress &&
      request.actualDeliveryAddress !== request.deliveryAddress,
    );
  }
}
